import { IDate } from "../../../models"

export interface ITimecardSequenceWarningData {
    WarningItems: ITimecardSequenceWarningItem[]
    Type: ETimecardSequenceActionType
}

export interface ITimecardSequenceWarningItem {
    UserId: string
    Name: string
    ExternalId: string
    LockDates: IDate[]
    ActionByName: string
    ByPendingPunch: boolean
}

export enum ETimecardSequenceActionType {
    GetPayroll,
    LockPayroll,
    LockOpenedPunchSet,
    ApprovePunchSetTimecard,
    UnapprovePunchSetTimecard,
    ReviewLocException,
    ReviewBioException,
    ExceptionReviewedAlready,
    ExportToThirdParty,
    RecalculateTimecard,
    LockSupUnapprovedPunchSet,
    LockEmpUnapprovedPunchSet,
    LockSupUnapprovedExpenses,
    LockEmpUnapprovedExpenses,
    LockSuspensePunches,
    EmployeeLockPayroll,
}